import {getTables, addDataSource, updateDataSource, deleteDataSource, getDataSources, createDataSource, transformPaste, transformSQL, mergeDataSource} from '@/models/data-source';
import Vue from 'vue';
import JwtService from '@/services/jwt.service';
import {getFromStorage, saveInStorage} from '@/services/localstorage.service';
const user = JwtService.getUser();

const inputTransformations = {
  'paste': transformPaste,
  'sql': transformSQL
}
export default {
  async aInit(context, dataSource) {


  //  let d = createDataSource({name: 'Fake Sheet', projectId: context.state.projectId, type: 'paste'});
  //  d.setData("");
    // console.log("first update");
    // dataSource.pageSize = context.state.pageSize;
//    d.update();

    let tables = await getTables();
    context.commit('mSetTables', tables);
    let dataSources = [];
    try {

      let d  = await getDataSources({projectId: context.state.projectId}, true);
      for(let i = 0; i < d.length; i++) {
        if(d[i].type == "default") {
          // console.log("deleting default", d[i]);
          await deleteDataSource(d[i]);
        } else {
          dataSources.push(d[i]);
        }

      }

    } catch(err) {

    }
//    console.log("projectId", context.state.projectId);
//    console.log("dataSources", dataSources.length);
    if(dataSources.length == 0) {
      // dataSource.projectId = context.state.projectId;
    //  dataSource.name = "Sheet 1";
    //  await context.dispatch('aAdd');
      context.commit('mInit', []);
    } else if (dataSources.length) {
      // found database value
      context.commit('mInit', dataSources);
    }
  },
  async aCreateMerge(context, dataSource) {
    console.log("datasoure to merge ", dataSource);
    if(dataSource.type == "union_view") {
      return false;
    }
    if(dataSource.id == null || isNaN(dataSource.id)) {
      return false;
    } else {

    }

    let unionDatasource = {...dataSource};
    unionDatasource.type = 'union_view';
    const c = context.state.dataSources.filter(d => d.type == 'union_view').length + 1;
    unionDatasource.name = 'Merged Worksheet ' + c;
    unionDatasource.status = 'live';
    delete(unionDatasource.id);
    unionDatasource = await addDataSource(unionDatasource);

    unionDatasource.childrenIds = [dataSource.id];
    await mergeDataSource(unionDatasource);
    context.dispatch("aInit");
  },
  async aMerge(context, dataSource) {

    if(dataSource.type != "union_view") {
      return false;
    }
    if(dataSource.id == null || isNaN(dataSource.id)) {
      delete dataSource.id;
    } else {

    }
    await mergeDataSource(dataSource);
    context.dispatch("aInit");
  },
  async aMerges(context, relatedSources) {

    for(let i = 0; i < relatedSources.length; i++) {
      let source = relatedSources[i];
      let dataSource = source.dataSource;
      if(dataSource.id == null || isNaN(dataSource.id)) {
        delete dataSource.id;
        dataSource = await addDataSource(dataSource);
        // console.log("new data sources is",  dataSource);
      }
      await mergeDataSource(dataSource);
    }
    // return await getDataSources({projectId: context.state.projectId});
  },
  async aGetDataSources(context, dataSource) {
    return await getDataSources({projectId: context.state.projectId});
  },
  async aAdd ({ state, commit, rootState, dispatch })  {
    const append = state.dataSources.length + 1;
    const user = JwtService.getUser();
    let dataSource = createDataSource({name: 'Sheet ' + append, projectId: state.projectId});

    delete dataSource.id;
    dataSource.userId = user.id;
    // commit('mSetInput');
    // await dispatch('aTransformInput', dataSource);
    let newDataSource = await addDataSource(dataSource);

    //console.log("newDataSource", newDataSource);

    // commit('mSetDataSource', newDataSource);
    commit('mAdd', newDataSource);
    let dataSources  = await getDataSources({projectId: state.projectId}, true);

  },
  async aAddFromTable ({ state, commit, rootState, dispatch }, tableName)  {
    const append = state.dataSources.length + 1;
    const user = JwtService.getUser();
    let dataSource = createDataSource({name: tableName + ' ' + append, projectId: state.projectId, type: 'jdbc:connection:postgresql', baseQuery: 'SELECT * FROM ' + tableName});

    delete dataSource.id;
    dataSource.userId = user.id;
    dataSource.type = "jdbc:connection:postgresql";
    // commit('mSetInput');
    // await dispatch('aTransformInput', dataSource);
    let newDataSource = await addDataSource(dataSource);
    //console.log("newDataSource", newDataSource);

    // commit('mSetDataSource', newDataSource);
    commit('mAdd', newDataSource);
    let dataSources  = await getDataSources({projectId: state.projectId}, true);

  },
  async aDelete({state, commit, rootState, dispatch }, dataSource)  {
    await deleteDataSource(dataSource);
    let dataSources  = await getDataSources({projectId: state.projectId}, true);
    commit('mDelete', dataSource);
    if(dataSources.length == 0) {
      commit('mInit', []);
      // await context.dispatch('aAdd');
    } else {
      commit('mInit', dataSources);
    }
    // let dataSources  = await getDataSources({projectId: state.projectId}, true);
  },
  async aUpdate ({state, commit, rootState, dispatch }, dataSource)  {
    commit('mLoading', true);
    commit('mSetInput');
    dataSource.projectId = state.projectId;
    await dispatch('aTransformInput', dataSource);
    if(!dataSource.transformed) {
      // try one more time
      await dispatch('aTransformInput', dataSource);
    }
    console.log("updating", dataSource);
    await updateDataSource(dataSource);
    commit('mSetDataSource', dataSource);
    commit('mLoading', false);
    // let dataSources  = await getDataSources({projectId: state.projectId}, true);
  },
  async aPaste ({state, commit, rootState, dispatch }, {dataSource, input})  {
    //console.log('pasted', input);
    // console.log(state);
    dataSource.input = input;
    // commit('mPaste', dataSource, );
    await dispatch('aTransformInput', dataSource);
    // dataSource.input = '';
    await updateDataSource(dataSource);
    commit('mUpdate', dataSource);
  },
  async aTransformInput({state}, dataSource) {
    //   console.log("udated here");
    dataSource.pageSize = state.pageSize;
    // dataSource.update();
    /**
    dataSource.transformed = false;
    if(inputTransformations.hasOwnProperty(dataSource.type)) {
      inputTransformations[dataSource.type](dataSource, state.dataSources).then(function(result) {
        dataSource.transformed = true;
        dataSource.setData(Object.freeze(result.data));
      }).catch(function(err) {
        dataSource.setData([]);
      });
    }**/
  }
};
